<template>
    <div class="checkbox-multi-select">
      <div class="checkbox-header" @click="toggleDropdown">
        <span>{{ displayText }}</span>
      </div>
      <div v-if="isOpen" class="checkbox-dropdown">
        <div
          v-for="option in options"
          :key="option.value"
          class="checkbox-item"
        >
          <input
            type="checkbox"
            :value="option.value"
            :id="option.value"
            v-model="selectedOptions"
            @change="updateSelection"
          />
          <label :for="option.value">{{ option.text }}</label>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      options: Array,
      selectedOptions: Array,
    },
    data() {
      return {
        isOpen: false,
        displayText: 'Select Columns',
      };
    },
    methods: {
      toggleDropdown() {
        this.isOpen = !this.isOpen;
      },
      updateSelection() {
        this.$emit('update:selected-options', this.selectedOptions);
        this.displayText = this.selectedOptions.length
          ? this.selectedOptions.join(', ')
          : 'Select Columns';
      },
    },
  };
  </script>
  
  <style scoped>
  .checkbox-multi-select {
    position: relative;
    display: inline-block;
    width: 200px;
  }
  
  .checkbox-header {
    background-color: #f1f1f1;
    padding: 8px;
    cursor: pointer;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  .checkbox-dropdown {
    position: absolute;
    background-color: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    width: 100%;
    z-index: 10;
    max-height: 200px;
    overflow-y: auto;
  }
  
  .checkbox-item {
    padding: 8px;
  }
  
  .checkbox-item:hover {
    background-color: #f0f0f0;
  }
  
  .checkbox-item input {
    margin-right: 8px;
  }
  </style>
  


// WEBPACK FOOTER //
// CheckboxMultiSelect.vue?5be735ec